var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "space-y-8" },
    _vm._l(_vm.options, function (option) {
      return _c(
        "button",
        {
          staticClass:
            "shadow sm:rounded-lg mb-6 block w-full text-left border-2 border-gray-50 transition-colors duration-200 focus:outline-none",
          class: {
            "bg-gray-50": option.value !== _vm.value,
            "border-primary-600 bg-white": option.value === _vm.value,
          },
          attrs: { type: "button", role: "radio" },
          on: {
            click: function ($event) {
              return _vm.$emit("input", option.value)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "px-4 py-5 sm:p-6 flex justify-between items-center",
            },
            [
              _c("div", [
                _c(
                  "h3",
                  {
                    staticClass: "text-lg leading-6 font-medium text-gray-900",
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(option.name) +
                        "\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "mt-2 max-w-xl text-sm leading-5 text-gray-500",
                  },
                  [
                    _c("p", [
                      _vm._v(
                        "\n                            " +
                          _vm._s(option.description) +
                          "\n                        "
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "w-8 h-8 rounded-full flex justify-center items-center transition-colors duration-200",
                  class: {
                    "bg-gray-50 text-gray-50": option.value !== _vm.value,
                    "bg-primary-200 text-primary-600":
                      option.value === _vm.value,
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "w-6 h-6",
                      attrs: {
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M5 13l4 4L19 7",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }